import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './shared/component/layout/layout.component';
import { AuthComponent } from '@modules/auth/page/auth.component';
import { DashboardComponent } from '@modules/dashboard/page/dashboard.component';
import { RoadTaxComponent } from '@modules/roadtax/page/requestquotation/roadtax.component';
import { QuotationSuccessComponent } from '@modules/roadtax/page/successquotation/quotation-success.component';
import { QuoteComparisonComponent } from '@modules/quotecomparison/page/quotecomparison.component';
import { ReceiptComponent } from '@modules/receipt/page/receipt.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: AuthComponent
  },
  {
    path: 'requestquotation',
    component: RoadTaxComponent,
    pathMatch: 'full',
    canActivate: []
  },
  {
    path: 'returnstatus',
    component: QuotationSuccessComponent,
    pathMatch: 'full',
    canActivate: []
  },
  {
    path: 'getquotation',
    component: QuoteComparisonComponent,
    pathMatch: 'full',
    canActivate: []
  },
  {
    path: 'paymentreceipt',
    component: ReceiptComponent,
    pathMatch: 'full',
    canActivate: []
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('@modules/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'user',
        loadChildren: () =>
          import('@modules/user/user.module').then(m => m.UserModule)
      },
      {
        path: 'customer',
        loadChildren: () =>
          import('@modules/customer/customer.module').then(m => m.CustomerModule)
      },
      {
        path: 'quotation',
        loadChildren: () =>
          import('@modules/quotation/quotation.module').then (m => m.QuotationModule)
      },
      {
        path: 'vehicle',
        loadChildren: () =>
          import('@modules/vehicle/vehicle.module').then (m => m.VehicleModule)
      },
      {
        path: 'insurance',
        loadChildren: () =>
          import('@modules/insurance/insurance.module').then (m => m.InsuranceModule)
      },
      {
        path: 'template',
        loadChildren: () =>
          import('@modules/template/template.module').then (m => m.TemplateModule)
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('@modules/myprofile/myprofile.module').then (m => m.MyProfileModule)
      },
      {
        path: 'requestquotation',
        loadChildren: () =>
          import('@modules/roadtax/roadtax.module').then (m => m.RoadTaxModule)
      },
      {
        path: 'getquotation',
        loadChildren: () =>
          import('@modules/quotecomparison/quotecomparison.module').then (m => m.QuoteComparisonModule)
      },
      {
        path: 'company',
        loadChildren: () =>
          import('@modules/company/company.module').then (m => m.CompanyModule)
      },
      {
        path: 'paymentreceipt',
        loadChildren: () =>
          import('@modules/receipt/receipt.module').then (m => m.ReceiptModule)
      }
    ]
  },
  { path: '**', redirectTo: '/dashboard/dashboard', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
